import { createTheme } from '@mui/material/styles';

import { components } from './components';
import { typography } from './typography';

const theme = createTheme({
  palette: {
    primary: {
      light: '#14141766',
      main: '#141417',
      contrastText: '#FFF',
    },
    backgroundPrimary: { main: '#FAFAFA', light: '#FFFFFF' },
    border: { main: '#DBDBDB', light: '#EFF0F0' },
    buttonPrimary: { main: '#FAB306' },
    buttonSecondary: { main: '#EFF0F0' },
    buttonDarkPrimary: {
      main: '#141417',
      contrastText: '#FFFFFF',
    },
    textDarkPrimary: { primary: '#141417' },
    textSecondary: { primary: '#6F6F6F' },
    success400: { main: '#73D648', light: '#DCF5D1' },
    success500: { main: '#57A635' },
    success600: { main: '#4A7628' },
    error500: { main: '#F20C0C', light: '#FDE1E1' },
    warning500: { main: '#EE7626', light: '#FCE4D4' },
    error600: { main: '#6A1A1A', light: '#B60000' },
    gray50: { main: '#F7F5F2' },
    gray200: { main: '#DBDBDB' },
    gray300: { main: '#C7C7C7' },
    gray500: { main: '#A1A1A1' },
    gray600: { main: '#46464E' },
    info500: { main: '#FAB306', light: '#FEECC1' },
    accentsYellowA: { main: '#FAB306', light: '#FAB30640' },
    accentsOrangeB: { main: '#C15710' },
    chipSuccess: {
      main: '#DCFCE7',
      contrastText: '#18472A',
    },
    chipDanger: {
      main: '#FEE2E2',
      contrastText: '#991B21',
    },
    inputReadonly: {
      main: '#f9fafb',
      contrastText: '#141417',
    },
  },
  typography,
  components,
});

export default theme;
